import React from 'react';
import { TimePicker as AntdTimePicker } from 'antd';
import type { TimePickerProps as AntdTimePickerProps } from 'antd';
import { joinAriaIds, useWxbFieldIds } from '../_internal/fieldA11y';
import { resolvePopupContainer } from '../_internal/portalContainer';
import './TimePicker.css';

export interface WxbTimePickerProps extends AntdTimePickerProps { label?: string; error?: string; }

export const WxbTimePicker: React.FC<WxbTimePickerProps> = ({
  label,
  error,
  className = '',
  id,
  'aria-describedby': ariaDescribedBy,
  'aria-invalid': ariaInvalid,
  // 全屏下面板就近渲染到触发器内;非全屏保持 antd 默认(body)。
  getPopupContainer = resolvePopupContainer,
  ...props
}) => {
  const { controlId, feedbackId } = useWxbFieldIds(id);
  const describedBy = joinAriaIds(ariaDescribedBy, error ? feedbackId : undefined);

  return (
    <div className="wxb-field">
      {label && <label className="wxb-label" htmlFor={controlId}>{label}</label>}
      <AntdTimePicker
        {...props}
        id={controlId}
        className={`wxb-timepicker ${error ? 'wxb-tp-error' : ''} ${className}`}
        popupClassName="wxb-timepicker-popup"
        getPopupContainer={getPopupContainer}
        aria-describedby={describedBy}
        aria-invalid={ariaInvalid ?? (Boolean(error) || undefined)}
        status={error ? 'error' : props.status}
      />
      {error && <span id={feedbackId} className="wxb-help wxb-help-error" role="alert">{error}</span>}
    </div>
  );
};
